<template>
  <v-card class="mb-4 app">
    <v-container>
      <v-row>
        <v-col cols="9">
          <Container
            @click="handleDragStart('valoresDisponiveisComboBox', $event)"
            :get-child-payload="getChildPayload"
            :drop-placeholder="{ class: 'placeholder' }"
          >
            <v-select
              class="mt-5"
              multiple
              v-model="selecinadoComboBox"
              :items="valoresDisponiveisComboBox"
              item-text="description"
              :label="dragname"
              return-object
              outlined
              dense
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.description ? item.description : item }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ selecinadoComboBox.length - 1 }}) </span>
                </v-chip>
              </template>
            </v-select>
            <v-dialog scrollable persistent v-model="dialog">
              <v-card color="background">
                <v-card-title>
                  <span>{{ acaoSelecionada.description }}</span>
                </v-card-title>
                <v-divider />

                <v-card-text>
                  <Dialog
                    :acao="acaoSelecionada"
                    :key="componentKey"
                    @form="updateForm($event)"
                    @error="error($event)"
                  />
                </v-card-text>

                <v-divider />

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="FormSalvar(acaoSelecionada)">Salvar </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </Container>
        </v-col>
        <v-col class="text-right" cols="3">
          <v-btn class="mt-5 mr-4" color="bluePcm" dark @click="insere()">Selecionar</v-btn>
          <v-spacer />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-subheader>{{ dragname.toUpperCase() }}</v-subheader>
          <v-list-item-group v-model="item">
            <Container
              :group-name="dragname"
              @drag-start="handleDragStart('ValoresSelecionadosDrag', $event, ValoresSelecionadosDrag)"
              @drop="handleDrop('ValoresSelecionadosDrag', $event)"
              :get-child-payload="getChildPayload"
              :drop-placeholder="{ class: 'placeholder' }"
            >
              <v-list v-for="(valor, key) in ValoresSelecionadosDrag" :key="key" dense color="background">
                <v-list-item two-line>
                  <v-list-item-content @dblclick="atualizar(valor, key)">
                    <v-list-item-title>{{ valor.description }} </v-list-item-title>
                    <v-list-item-subtitle v-if="valor.tipo === 'ativarRegra' || valor.tipo === 'desativarRegra'">
                      Rota: {{ valor.rota_description }} /
                      {{ valor.regex_description }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else-if="valor.tipo === 'logarAgente'">
                      Agente: {{ valor.agente_name }} / Ramal: {{ valor.ramal }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else-if="valor.tipo === 'deslogarAgente'">
                      Agente: {{ valor.agente_name }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else-if="valor.tipo === 'backup'">
                      Opção: {{ valor.backup_opc }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else-if="valor.tipo === 'deslogarDepartamento'">
                      Departamento: {{ valor.departament_name }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-switch dense v-model="valor.active" />
                      </div>
                    </template>
                    <span>Ativar/Desativar</span>
                  </v-tooltip>
                  <v-list-item-icon class="mt-5">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="mr-1" color="orangePcm" @click="atualizar(valor, key)" v-bind="attrs" v-on="on">
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>Atualizar</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="darkRed" @click="remove(key)" v-bind="attrs" v-on="on">mdi-close-circle </v-icon>
                      </template>
                      <span>Remover</span>
                    </v-tooltip>
                  </v-list-item-icon>
                </v-list-item>
                <v-divider class="mx-2" />
              </v-list>
            </Container>
          </v-list-item-group>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Container } from 'vue-smooth-dnd'

import { registerVuexModule } from '@/utils/vuexUtils'

import agendamentosStore from '../_store'

import Dialog from './Dialog'

export default {
  name: 'DraggAndDrop',
  props: {
    dragname: String,
    valoresDisponiveisComboBox: Array,
    opcoesSelecionadas: Array,
  },
  components: { Container, Dialog },

  data: () => ({
    item: -1,
    selecinadoComboBox: [],
    ValoresSelecionadosDrag: [],
    dialog: false,
    acaoSelecionada: {},
    keySelecionada: null,
    componentKey: 0,
    form: {},
    nomeRota: '',
    nomeRegex: '',
    rotasAplicacao: [],
  }),

  computed: {
    ...mapGetters('draggAndDropAgendamentoTarefasModulePABXStore', ['getRotas']),
  },

  async created() {
    registerVuexModule(this.$store, 'draggAndDropAgendamentoTarefasModulePABXStore', agendamentosStore)

    await this.listarRotas()

    this.rotasAplicacao = [...this.getRotas]
  },

  methods: {
    ...mapActions('draggAndDropAgendamentoTarefasModulePABXStore', ['listarRotas']),
    handleDragStart(lane, dragResult, value) {
      const { payload, isSource } = dragResult
      if (isSource) {
        this.draggingCard = {
          lane,
          index: payload.index,
          cardData: {
            value: value[payload.index],
          },
        }
      }
    },
    handleDrop(lane, dropResult) {
      const { removedIndex, addedIndex } = dropResult
      if (lane === this.draggingCard.lane && removedIndex === addedIndex) {
        return
      }

      if (removedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(removedIndex, 1)
      }

      if (addedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(addedIndex, 0, this.draggingCard.cardData.value)
      }
    },
    insere() {
      this.selecinadoComboBox.forEach(valorSelecionado => {
        this.ValoresSelecionadosDrag.push(Object.assign({}, valorSelecionado))
      })
    },
    remove(key) {
      this.valoresDisponiveisComboBox.push(this.ValoresSelecionadosDrag[key])
      this.ValoresSelecionadosDrag.splice(key, 1)
    },

    atualizar(valor, key) {
      this.componentKey += 1
      this.dialog = true
      this.keySelecionada = key
      this.acaoSelecionada = valor
    },
    getChildPayload(index) {
      return {
        index,
      }
    },
    updateForm(event) {
      this.form = Object.assign({}, event)
    },
    FormSalvar() {
      this.errorMessage.$touch()
      if (this.errorMessage.$error) {
        return
      } else {
        this.ValoresSelecionadosDrag.splice(this.keySelecionada, 1, this.form)
        this.dialog = false
      }
    },
    error(error) {
      this.errorMessage = error
    },
  },
  watch: {
    ValoresSelecionadosDrag(dragnovo) {
      this.$emit('dragUpdate', dragnovo)
      dragnovo.forEach(async (novoDrag, key) => {
        if (!novoDrag.rota_description) {
          const indexRota = this.rotasAplicacao.findIndex(rota => rota._id === novoDrag.rota_id)
          let indexRegexRota = -1

          if (indexRota !== -1) {
            indexRegexRota = this.rotasAplicacao[indexRota].regex.findIndex(
              regex => regex.regex_id === novoDrag.regex_id
            )

            if (indexRegexRota !== -1) {
              const regexVisualDestino = this.rotasAplicacao[indexRota].regex[indexRegexRota].regexVisualDestino
              const regexVisualOrigem = this.rotasAplicacao[indexRota].regex[indexRegexRota].regexVisualOrigem
              const alliasRegexDestinoDescription = this.rotasAplicacao[indexRota].regex[indexRegexRota]
                .alliasRegexDestinoDescription
              const alliasRegexOrigemDescription = this.rotasAplicacao[indexRota].regex[indexRegexRota]
                .alliasRegexOrigemDescription

              dragnovo[key].regex_description = 'REGEX DESTINO:'
              if (regexVisualDestino) {
                dragnovo[key].regex_description = `${dragnovo[key].regex_description} ${regexVisualDestino}`
              }

              if (regexVisualDestino && alliasRegexDestinoDescription) {
                dragnovo[key].regex_description = `${dragnovo[key].regex_description} |`
              }

              if (alliasRegexDestinoDescription) {
                dragnovo[key].regex_description = `${dragnovo[key].regex_description} ${alliasRegexDestinoDescription}`
              }

              dragnovo[key].regex_description = `${dragnovo[key].regex_description}; REGEX ORIGEM:`

              if (regexVisualOrigem) {
                dragnovo[key].regex_description = `${dragnovo[key].regex_description} ${regexVisualOrigem}`
              }

              if (regexVisualOrigem && alliasRegexOrigemDescription) {
                dragnovo[key].regex_description = `${dragnovo[key].regex_description} |`
              }

              if (alliasRegexOrigemDescription) {
                dragnovo[key].regex_description = `${dragnovo[key].regex_description} ${alliasRegexOrigemDescription}`
              }

              dragnovo[key].rota_description = this.rotasAplicacao[indexRota].description
              dragnovo.splice(key, 1, dragnovo[key])
            }
          }
        }
      })
    },
    opcoesSelecionadas: {
      deep: true,
      immediate: true,
      handler(novo) {
        let array = []
        novo.forEach(opcao => {
          if (typeof opcao === 'object') {
            array.push(Object.assign({}, opcao))
          } else {
            array.push(opcao)
          }
        })
        this.ValoresSelecionadosDrag = array
      },
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
